"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBlockSelect = addBlockSelect;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _ToolbarButton = _interopRequireDefault(require("rich-text-lib/components/toolbar/ToolbarButton"));

var _TinyMceFormatSelect = _interopRequireDefault(require("../components/toolbar/TinyMceFormatSelect"));

var _toolbar = require("../constants/toolbar");

var _hsformatting = require("../constants/hsformatting");

var _usageTracking = require("../constants/usageTracking");

var _usageTracking2 = require("../utils/usageTracking");

var _utils = require("../utils");

var _formatting = require("../utils/formatting");

var _i18n = require("../utils/i18n");

var i18nKey = (0, _i18n.i18nWithNameSpace)(_hsformatting.i18nNameSpace);
var blockSelectMenuItemi18n = 'blockSelectMenuItem';
var removeFormatTooltipi18n = 'clearStyles';
var SECTIONS = {
  paragraph: ['p'],
  headings: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  other: ['blockquote', 'div', 'pre', 'code']
};

var getBlockquoteFormatHandler = function getBlockquoteFormatHandler(editor) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blockquote';
  return function () {
    var selectedNode = editor.selection.getNode();
    var target; // Set the target node to the <li> item or the whole list when appropriate

    var listNode = (0, _formatting.getListNode)(editor, selectedNode);

    if (listNode) {
      target = listNode;
    } else if ((0, _formatting.isListParentNode)(selectedNode)) {
      target = selectedNode;
    }

    if (target) {
      editor.undoManager.transact(function () {
        var bm = editor.selection.getBookmark();
        editor.formatter.toggle(format, {}, target);
        editor.selection.moveToBookmark(bm);
        editor.selection.collapse();
      });
    } else {
      editor.execCommand('mceToggleFormat', false, format);
    }
  };
};

function createBlockChangeHandler(items, editor) {
  return function (_ref) {
    var control = _ref.control;
    editor.on('NodeChange', function (event) {
      control.value(null);

      if (!event.element) {
        return;
      }

      var matched = items.find(function (item) {
        return editor.formatter.match(item.value);
      });

      if (matched) {
        control.value(matched.value);
      } else if (items) {
        control.value(items[0].value);
      }
    });
  };
}

function createBlockSelectMenu(styleFormats) {
  return Object.keys(SECTIONS).reduce(function (items, section) {
    var includedFormats = styleFormats.filter(function (styleFormat) {
      return SECTIONS[section].indexOf(styleFormat.format) > -1;
    }).map(function (styleFormat) {
      return {
        text: {
          raw: styleFormat.title
        },
        value: styleFormat.format,
        disabled: styleFormat.disabled,
        tooltip: styleFormat.tooltip
      };
    });

    if (items.length > 0 && includedFormats.length) {
      includedFormats[0].classes = 'new-section';
    }

    return [].concat((0, _toConsumableArray2.default)(items), (0, _toConsumableArray2.default)(includedFormats));
  }, []);
}

function createBlockItemClickHandler(editor, method) {
  return function (event) {
    var format = event.control.settings.value;

    if (format) {
      editor.formatter.apply(format);
      (0, _usageTracking2.trackInteraction)(editor, 'tinymceFormatting', _usageTracking.CHANGE_BLOCK_FORMAT, {
        method: method,
        value: format
      });
    }
  };
}

function addKeyboardSortcuts(editor) {
  for (var i = 1; i <= 6; i++) {
    editor.addShortcut("meta+" + i, '', ['FormatBlock', false, "h" + i]);
  }

  editor.addShortcut('meta+7', '', ['FormatBlock', false, 'p']);
  editor.addShortcut('meta+8', '', ['FormatBlock', false, 'div']);
  editor.addShortcut('meta+9', '', ['FormatBlock', false, 'address']);
}

function addBlockSelect(editor) {
  addKeyboardSortcuts(editor);
  editor.addCommand('hsblockquote', getBlockquoteFormatHandler(editor));
  var blockStyleFormats = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.BLOCK_FORMATS, _hsformatting.BLOCK_FORMATS);
  var blockItems = createBlockSelectMenu(blockStyleFormats);
  editor.addButton('block', function () {
    return {
      type: 'listbox',
      text: i18nKey(blockSelectMenuItemi18n),
      tooltip: i18nKey(blockSelectMenuItemi18n),
      values: blockItems,
      fixedWidth: true,
      onPostRender: createBlockChangeHandler(blockItems, editor),
      onselect: createBlockItemClickHandler(editor, 'button')
    };
  });
  editor.addButton('hsremoveformat', function () {
    return {
      classes: 'removeFormatButton',
      icon: 'hsremoveformat',
      tooltip: i18nKey(removeFormatTooltipi18n),
      onclick: function onclick() {
        editor.execCommand('RemoveFormat');
      }
    };
  });
  editor.addButton('canvasblock', function () {
    return {
      type: _toolbar.CANVAS_BUTTON_TYPE,
      renderControl: function renderControl(props) {
        return _react.default.createElement(_TinyMceFormatSelect.default, (0, _extends2.default)({
          editor: editor,
          formats: blockItems.map(function (_ref2) {
            var text = _ref2.text.raw,
                value = _ref2.value,
                disabled = _ref2.disabled,
                tooltip = _ref2.tooltip;
            return {
              text: text,
              value: value,
              disabled: disabled,
              tooltip: tooltip
            };
          })
        }, props));
      }
    };
  });
  editor.addButton('canvasremoveformat', {
    type: _toolbar.CANVAS_BUTTON_TYPE,
    renderControl: function renderControl(props) {
      return _react.default.createElement(_ToolbarButton.default, (0, _extends2.default)({
        iconName: "removeTextStyle",
        tooltip: i18nKey(removeFormatTooltipi18n),
        onClick: function onClick() {
          editor.execCommand('RemoveFormat');
        },
        selected: false
      }, props));
    }
  });
}